import { render, staticRenderFns } from "./prompt-form.vue?vue&type=template&id=54ea3376&"
import script from "./prompt-form.vue?vue&type=script&lang=js&"
export * from "./prompt-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports